import { render, staticRenderFns } from "./EmpCertification.vue?vue&type=template&id=75610248&scoped=true"
import script from "./EmpCertification.vue?vue&type=script&lang=js"
export * from "./EmpCertification.vue?vue&type=script&lang=js"
import style0 from "./EmpCertification.vue?vue&type=style&index=0&id=75610248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75610248",
  null
  
)

export default component.exports